import React, { memo, ReactElement } from "react";
import ContentFrame from "components/ContentFrame/ContentFrame";
import LogItem from "./LogItem";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import InfoIcon from "@material-ui/icons/Info";
import ErrorIcon from "@material-ui/icons/Error";
import CheckIcon from "@material-ui/icons/Check";

import { useSelector } from "react-redux";
import { StoreState, LogBoxItem } from "models";

const LogBox = () => {
  const logs: LogBoxItem[] = useSelector((state: StoreState) => state.logbox.logs);

  const chooseIcon = (severity: string): ReactElement => {
    switch (severity) {
      case "success":
        return <CheckIcon />;
      case "warning":
        return <WarningRoundedIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        return <InfoIcon />;
    }
  };

  return (
    <ContentFrame title="Logs">
      <div>
        {logs.map((log: LogBoxItem, index: number) => {
          const icon = chooseIcon(log.severity);
          return <LogItem key={index} logItem={log} icon={icon}></LogItem>;
        })}
      </div>
    </ContentFrame>
  );
};

export default memo(LogBox);
